import React, { useCallback, useMemo, memo } from "react";
import { useDispatch } from "react-redux";
import momentTz from 'moment-timezone';

import { renderModuleType } from "../../util";
import FileView from "../../../../components/FileView";
import { updateCaptionTodo } from "../../../../containers/Diaries/actions";
import Icon from "../../../../icons";
import { DEFAULT_TIME_FORMAT } from '../../../../common/constants';
import UserImage from '../../../../components/UserImage/index';

const renderTagList = (tags, extraClass, testId) =>
    tags?.map((tag) => (
        <label className={`mr status tags ${extraClass}`} key={tag} data-test={testId}>
            {tag}
        </label>
    ));

const Detail = ({ data, status, userTimeZone }) => {
    const dispatch = useDispatch();

    const {
        OwnerView,
        PriortyTitle,
        Priorty,
        IsCompleted,
        Status,
        PreetyDueDate,
        PreetyReminderDate,
        PreetyCompletedDate,
        PreetyDeletedDate,
        SystemTags,
        NoSystemTags,
        fileData,
        Description,
    } = data;

    const showHighPriorityFlag = Priorty == 3 && !IsCompleted && Status == "OPEN";

    const completedOnDate = useMemo(
        () => PreetyCompletedDate || momentTz().tz(userTimeZone).format(DEFAULT_TIME_FORMAT),
        [PreetyCompletedDate, userTimeZone]
    );

    const handleUpdateFileCaption = useCallback(
        (fileCaptionData) => dispatch(updateCaptionTodo(fileCaptionData)),
        [dispatch]
    );

    return (
        <React.Fragment>
            <div className="wkDetailInfo">
                <div className="diaryWkTitle alignMiddle">
                    {renderModuleType(data, true)}
                </div>
                <ul className="rowSpaceBetween alignMiddle">
                    <li data-test="DiaryOwner">
                        <span className="userGroup diaryUser">
                            <div className="rowFlex">
                                <div className="userPic userPicIcon">
                                    <UserImage
                                        profileUrl={OwnerView.ProfileFullImage}
                                        profileName={OwnerView.DisplayName}
                                    />
                                </div>
                                <div className="userInfo flexWrap">
                                    <span>{OwnerView.DisplayName}</span>
                                    <label>Diary Owner</label>
                                </div>
                            </div>
                        </span>
                    </li>
                    <li>
                        <div className="rowFlex wrapFlex alignMiddle diaryOwner alignRight">
                            <span
                                className="quickTooltip-top alignMiddle mr__1"
                                data-quicktooltip={OwnerView.Phone || 'NA'}
                                data-test="OwnerMobile"
                            >
                                <Icon name="mobile" className="mobile svg-call" />
                            </span>
                            <span
                                className="quickTooltip-top alignMiddle email rightAlign"
                                data-quicktooltip={OwnerView.Email}
                                data-test="OwnerEmail"
                            >
                                <Icon name="email" className="email svg-email" />
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <div className="wkDetailInfo">
                <ul className="rowFlex wrapFlex">
                    <li data-test="Priority">
                        <label>Priority</label>
                        <span>
                            {PriortyTitle}
                            {showHighPriorityFlag && (
                                <span className="priority animated superFaster flagHigh delay-5 mr">
                                    <Icon name="flag" className="icon ml" />
                                </span>
                            )}
                        </span>
                    </li>
                    <li data-test="Due On">
                        <label>Due On</label>
                        <span>{PreetyDueDate}</span>
                    </li>
                    <li data-test="Reminder On">
                        <label>Reminder On</label>
                        <span>{PreetyReminderDate || "-"}</span>
                    </li>
                </ul>
            </div>

            {status == "COMPLETED" && (
                <div className="reminder mb mt" data-test="Completed On">
                    <label>Completed On</label>
                    <date>{completedOnDate}</date>
                </div>
            )}

            {Status == "CANCELLED" && (
                <div className="reminder mb mt" data-test="Cancelled On">
                    <label>Cancelled On</label>
                    <date>{PreetyDeletedDate}</date>
                </div>
            )}

            <div className="mb mt formTags">
                <label>Tags</label>
                {renderTagList(SystemTags, "", "SystemTags")}
                {renderTagList(NoSystemTags, "ReactTags__tag", "NoSystemTags")}
            </div>

            <div className="attachMent mb" data-test="Attachment">
                <label>Attachment</label>
                {fileData.Files.length ? (
                    <div className="fileAttachment addFile">
                        <FileView
                            fileData={fileData}
                            galleryData={[]}
                            updateFileCaption={handleUpdateFileCaption}
                        />
                    </div>
                ) : (
                    <p>No Files available.</p>
                )}
            </div>

            <div className="description">
                <label>Description</label>
                {Description ? (
                    <p className="descriptionFormating" dangerouslySetInnerHTML={{ __html: Description }} />
                ) : (
                    "-"
                )}
            </div>
        </React.Fragment>
    );
};

export default memo(Detail);